import { Page } from '../../types'

const civilCostAwards: Page[] = [
    {
        pageType: 'question',
        title: 'Civil cost awards',
        name: 'civil-cost-awards',
        questions: [
            {
                questionType: 'instanceInput',
                title: 'Total number of instances',
                name: 'civil-cost-awards-total-instances',
                hint: '',
                rules: {
                    required: false
                }
            },
            {
                questionType: 'costInput',
                title: 'Estimated total value',
                name: 'civil-cost-awards-estimated-total',
                hint: '',
                rules: {
                    required: false
                }
            },    
            {
                questionType: 'textarea',
                title: 'Comments',
                name: 'civil-cost-awards-text-comments',
                hint: 'Please ensure you do not include any personal or sensitive information',
                rules: {
                    required: false
                }
            }
        ]
    },
]
export default civilCostAwards
